import { CharacterBaseState } from './types'
import { CharactersSlice } from './store.d'
import { CHARACTER_TYPES } from '../../f.assets/Characters/scripts/constants'
import { COMMANDERS, LevelSlice } from '../LevelManager/store.d'
import { Player } from '../LevelManager/store.d'
import { useScenesStore } from '../../b.providers/ScenesProvider/store'

export const SEL_GET_MINIONS = (s: CharactersSlice): Record<string, CharacterBaseState> => {
  const states = s.characters.data.characterStates
  return Object.keys(states).reduce((res: any, key) => {
    if (states[key].type === CHARACTER_TYPES.BASIC_MINION) {
      res[key] = states[key]
    }
    return res
  }, {})
}

export const SEL_STATE_BY_UUID = (uuid: string) => (s: CharactersSlice) => s.characters.data.characterStates[uuid]
export const SEL_TEAM_BY_UUID = (uuid: string) => (s: CharactersSlice & LevelSlice) => {
  const state = s.characters.data.characterStates[uuid] as CharacterBaseState
  const owner = state && s.levels.data.players.find((p: Player) => p.id === state.owner)
  const homeTeam = useScenesStore.getState().user.team
  const awayTeam = homeTeam === CHARACTER_TYPES.JACK ? CHARACTER_TYPES.WITCH : CHARACTER_TYPES.JACK
   
  return owner?.id === COMMANDERS.PLAYER ? homeTeam : awayTeam
}
export const SEL_SELECTED_STATE_UUID = (s: CharactersSlice) => s.characters.data.selectedCharacterUUID